const { bindLangToggleSetDefault } = require('../lang-toggle');
// const htmlHeader = require('../../includes/header.html');
module.exports = function italianPartial() {
    // custom Hub functions

    let italianLoaded = false;
    // document.querySelector('body').insertAdjacentHTML('afterbegin', htmlHeader());
    Hubs.Events.on('load', () => {
            if (!italianLoaded) {

                // Call all on load functions here
                bindLangToggleSetDefault('Italiano');
                italianLoaded = true;
            }
        })
        .on('itemsLoaded', (itemIds, selectors) => {
            // Call all itemsLoaded events here

        })
        .on('resize', () => {
            // Call all resize events here
            // bindLangToggleSetDefault('Italiano');
        })
        .on('scroll', () => {
            // Call all scroll events here
        })
        .on('ctaActivate', (ctaId) => {
            // Call all ctaActivate events here
        })
        .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
            // Call all ctaFormSubmitSuccess events here
        });
};


// WEBPACK FOOTER //
// ./scriptPartials/hubSpecificFunctions/_italian.js